import { Col, Row } from "antd";
import React, { useRef, useState } from "react";
// import PropTypes from "prop-types";
import "../../styles/drop-file-input.css";
// import uploadImg from "../../assets/dropFile/cloud.svg";
// import Col from "react-bootstrap/Col";
// import Row from "react-bootstrap/Row";

import { useEffect } from "react";
import Icon from "../../assets/Icon";

const DropFileInput = (props) => {
  const wrapperRef = useRef(null);
  const [fileList, setFileList] = useState([]);

  const onDragEnter = () => wrapperRef.current.classList.add("dragover");

  const onDragLeave = () => wrapperRef.current.classList.remove("dragover");

  const onDrop = () => wrapperRef.current.classList.remove("dragover");

  const onFileDrop = (e) => {
    const newFile = e.target.files[0];
    const fileType = newFile.type;
    if (
      fileType === "application/pdf" ||
      fileType ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
      fileType === "application/msword"
    ) {
      const updatedList = [newFile];
      setFileList(updatedList);
      props.onFileChange(updatedList);
    } else {
      alert("Please only upload PDF or DOC file");
      return;
    }
  };
// console.log(props.resumeName)
  return (
    <>
      <div
        ref={wrapperRef}
        className="drop-file-input"
        onDragEnter={onDragEnter}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
      >
        {/* <img src={uploadImg} alt="" />
          <p>
            Drag & Drop or click to upload <br /> your job escription document
            here <br />{" "}
            <span style={{ fontSize: "11px" }}>
              PDF, DOC, DOCX files are allowed
            </span>
          </p> */}
        <div className="flex flex-col justify-center items-center">
          <div>
            <Icon type="upload-file-icon" />
          </div>
          <div>
            <h4>
              <span style={{ color: "#206DC5" }}>{props.upload}</span>{" "}
              {props.dragDrop}
            </h4>
            <p className="font-bold text-center m-0 pb-1">
              {props.resumeNameHeader}
            </p>
            {props.resumeName ? (
              <p className="text-center text-[#206DC5] break-words">{props.resumeName}</p>
            ) : (
              <div className="text-center">
                <p className="text-[#475467]">
                  {" "}
                  <span className="text-[#206DC5] font-semibold">Click to upload</span> or drag and drop{" "}
                </p>
                <p className="text-[#475467]">PDF, DOC, DOCX (max size 3MB)</p>
              </div>
            )}
          </div>
        </div>

        <input
          className="block m-auto mt-4 w-[230px]"
          type="file"
          value=""
          accept={
          "application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          }
          onChange={onFileDrop}
        />
      </div>
    </>
  );
};

// DropFileInput.propTypes = {
//   onFileChange: PropTypes.func,
// };

export default DropFileInput;
